/* SoBe Shop the Look (Frank 2026-10-08): dots on a room photo open a product card; Add to cart uses the
   theme's own cart drawer. Event delegation, so it also works after theme-editor section reloads. */
(function () {
  if (window.__sobeSTL) return;
  window.__sobeSTL = true;

  function cardOf(dot) { return document.getElementById(dot.getAttribute('aria-controls')); }
  function look(el) { return el.closest('.stl-look'); }

  function highlight(root, i) {
    if (!root) return;
    root.querySelectorAll('.stl-item').forEach(function (it) { it.classList.toggle('is-hl', i !== null && it.getAttribute('data-i') === String(i)); });
  }

  function close(dot, focusDot) {
    var card = cardOf(dot);
    dot.setAttribute('aria-expanded', 'false');
    if (card) card.hidden = true;
    highlight(look(dot), null);
    if (focusDot) dot.focus();
  }

  function closeAll(except) {
    document.querySelectorAll('.stl-dot[aria-expanded="true"]').forEach(function (d) { if (d !== except) close(d, false); });
  }

  // bottom edge of the theme's sticky header (if any), so a card is never hidden under it
  function headerBottom() {
    var el = document.elementFromPoint(window.innerWidth / 2, 4), b = 0;
    while (el && el !== document.body && el !== document.documentElement) {
      var pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') { b = Math.max(0, el.getBoundingClientRect().bottom); break; }
      el = el.parentElement;
    }
    return b;
  }

  // top edge of a fixed bar along the bottom (the phone call / directions bar), if any
  function footerTop() {
    var el = document.elementFromPoint(window.innerWidth / 2, window.innerHeight - 4), t = window.innerHeight;
    while (el && el !== document.body && el !== document.documentElement) {
      if (getComputedStyle(el).position === 'fixed') { t = Math.min(t, el.getBoundingClientRect().top); break; }
      el = el.parentElement;
    }
    return t;
  }

  function reveal(card) {
    // phones: also clear the floating accessibility / chat buttons that sit just above the bottom bar
    var r = card.getBoundingClientRect(), top = headerBottom() + 12, bottom = footerTop() - (window.innerWidth < 600 ? 118 : 12);
    if (r.top < top) window.scrollBy({ top: r.top - top, behavior: 'smooth' });
    else if (r.bottom > bottom) window.scrollBy({ top: Math.min(r.bottom - bottom, r.top - top), behavior: 'smooth' });
  }

  function open(dot) {
    var card = cardOf(dot);
    if (!card) return;
    if (dot.getAttribute('aria-expanded') === 'true') { close(dot, false); return; }
    closeAll(dot);
    var x = parseFloat(dot.getAttribute('data-x')) || 50;
    card.classList.remove('stl-card--top');
    card.classList.toggle('stl-card--left', x >= 50);      // card sits on the side away from the dot
    card.hidden = false;
    // if the dot would end up under the card (bottom corner), dock the card at the top instead
    var c = card.getBoundingClientRect(), d = dot.getBoundingClientRect();
    var dx = d.left + d.width / 2, dy = d.top + d.height / 2;
    if (dx > c.left - 26 && dx < c.right + 26 && dy > c.top - 26) card.classList.add('stl-card--top');
    dot.setAttribute('aria-expanded', 'true');
    highlight(look(dot), dot.getAttribute('data-i'));
    reveal(card);
  }

  function addToCart(btn) {
    if (btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-stl-add'), 10);
    var label = btn.textContent;
    var box = btn.closest('.stl-card, .stl-item');
    var msg = box && box.querySelector('.stl-msg');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.disabled = true;
    btn.textContent = 'Adding…';
    if (msg) { msg.textContent = ''; msg.classList.remove('is-ok'); }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      btn.textContent = 'Added ✓';
      btn.classList.add('is-added');
      var drawer = document.getElementById('CartDrawer');
      if (!drawer) { window.location.href = root + 'cart'; return; }
      // theme.js listens for "added.ajaxProduct" on <body> with its own bundled jQuery; the site also loads a second
      // jQuery later, so window.jQuery.trigger() never reaches it. A native "added" event does.
      document.body.dispatchEvent(new CustomEvent('added', { bubbles: false }));
      setTimeout(function () {
        if (msg && !/drawer--is-open/.test(drawer.className)) { msg.classList.add('is-ok'); msg.innerHTML = 'Added to your cart. <a href="' + root + 'cart">View cart</a>'; }
      }, 1500);
      setTimeout(function () { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-added'); }, 2600);
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = label;
      if (msg) msg.textContent = (err && err.description) || 'Sorry, that did not go through. Please try again or call (561) 221-6111.';
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var dot = t.closest('.stl-dot');
    if (dot) {
      e.preventDefault(); open(dot);
      if (e.detail === 0 && dot.getAttribute('aria-expanded') === 'true') { var f = cardOf(dot).querySelector('a[href]:not([tabindex]), button'); if (f) f.focus(); }
      return;
    }
    var x = t.closest('.stl-card__x');
    if (x) {
      var c = x.closest('.stl-card'), d = c && document.querySelector('.stl-dot[aria-controls="' + c.id + '"]');
      if (d) close(d, true);
      return;
    }
    var add = t.closest('[data-stl-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    if (!t.closest('.stl-card')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('.stl-dot[aria-expanded="true"]');
    if (d) close(d, true);
  });

  // list row hover lights up its dot on the photo
  function hover(e, on) {
    var it = e.target && e.target.closest && e.target.closest('.stl-item');
    if (!it) return;
    var lk = look(it), dot = lk && lk.querySelector('.stl-dot[data-i="' + it.getAttribute('data-i') + '"]');
    if (dot) dot.classList.toggle('is-hl', on);
  }
  document.addEventListener('mouseover', function (e) { hover(e, true); });
  document.addEventListener('mouseout', function (e) { hover(e, false); });

  function initScrollers() {
    document.querySelectorAll('.stl-look__scroll').forEach(function (sc) {
      var media = sc.parentElement, can = sc.scrollWidth > sc.clientWidth + 4;
      media.classList.toggle('can-scroll', can);
      if (can && !sc.__stl) {
        sc.__stl = true;
        sc.scrollLeft = (sc.scrollWidth - sc.clientWidth) / 2;
        setTimeout(function () { sc.addEventListener('scroll', function () { media.classList.add('is-scrolled'); }, { passive: true }); }, 400);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initScrollers); else initScrollers();
  window.addEventListener('load', initScrollers);
  var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(initScrollers, 200); });
  document.addEventListener('shopify:section:load', initScrollers);

  // arriving on #dining / #bedroom etc.: photos above load after the jump and can shift the page, so re-align once
  var userMoved = false;
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (t) { window.addEventListener(t, function () { userMoved = true; }, { passive: true, once: true }); });
  function realign() {
    if (userMoved) return;
    var id = decodeURIComponent((location.hash || '').slice(1)); if (!id) return;
    var el = document.getElementById(id); if (!el || !el.classList.contains('stl-look')) return;
    var want = headerBottom() + 8, off = el.getBoundingClientRect().top - want;
    if (Math.abs(off) > 8) window.scrollTo({ top: window.scrollY + off, behavior: 'auto' });
  }
  window.addEventListener('load', function () { setTimeout(realign, 700); setTimeout(realign, 1800); });
  window.addEventListener('hashchange', function () { setTimeout(realign, 400); });

  // theme editor: selecting a dot block opens its card so the position is easy to check
  document.addEventListener('shopify:block:select', function (e) {
    var d = document.querySelector('.stl-dot[data-block="' + (e.detail && e.detail.blockId) + '"]');
    if (d && d.getAttribute('aria-expanded') !== 'true') open(d);
  });
})();
